import {
  QuickFilter, Form, Flexbox,
} from '@/components'
import React from 'react'

function PetsFilter() {
  return (
    <QuickFilter
      initialValues={{
        animalName: '', tutorName: '',
      }}
      title="Filtrar pets na feira"
      renderForm={() => (
        <>
          <Flexbox.Column className="col-3 pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="animalName">Nome do animal</Form.Label>
              <Form.ValidationField
                name="animalName"
                className="input-sm"
                id="animalName"
                autoComplete="none"
                placeholder="Totó da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="tutorName">Nome do tutor</Form.Label>
              <Form.ValidationField
                name="tutorName"
                className="input-sm"
                id="tutorName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
        </>
      )}
    />
  )
}

export default PetsFilter
